<template>
    <v-form-element v-bind="$props">
        <input
            :id="id"
            :type="percentageInputType"
            :class="className"
            :placeholder="getPlaceholder()"
            v-model="formattedPercentage"
            :required="required"
            :disabled="disabled"
            @blur="focusOut"
            @focus="focusIn"
            @hover="$emit('hover')"
            @click="$emit('click')"
            @change="$emit('changed', $event)"
        />
    </v-form-element>
</template>

<script>

    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement
        },
        data() {
            return {
                percentageInputType: 'text',
                formattedPercentage: '0%'
            }
        },
        props: {
            allowDecimals: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            focusOut: function() {
                this.model = this.allowDecimals ? parseFloat(this.formattedPercentage) : parseInt(this.formattedPercentage, 10);
                if ( this.model ) {
                    this.formattedPercentage += '%';
                }
                this.percentageInputType = 'text';

                this.$emit('blur');
            },
            focusIn: function() {
                this.formattedPercentage = this.model;
                this.percentageInputType = 'number';

                this.$emit('focus');
            }
        },
        mixins: [mixin],
        computed: {
            model: {
                get() {
                    return this.getModel();
                },
                set(value) {
                    return this.setModel(value);
                }
            }
        },
        watch: {
            model() {
                if ( this.model ) {
                    this.formattedPercentage = this.model + '%';
                }
            },
        },
        mounted() {
            if ( this.model ) {
                this.formattedPercentage = this.model + '%';
            }
        }
    }
</script>
